import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RecipeBaseEffect } from './recipe-base.effect';
import { recipeBaseState } from './recipe-base.state';

@NgModule({
  imports: [
    StoreModule.forFeature(recipeBaseState),
    EffectsModule.forFeature([ RecipeBaseEffect ])
  ]
})
export class RecipeBaseModule {

}
